<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div
            class="w-100 mb-3 d-flex align-items-center justify-content-between"
          >
            <h1>جزئیات منابع درآمد (درصد)</h1>
          </div>
          <filters-wrapper @submitFilters="setFilters">
            <range-date-picker
              class="w-24 filters-width"
              label="بازه‌ی تاریخ منابع درآمد را وارد کنید"
              @getDateRange="setDateRange"
            ></range-date-picker>
            <!-- fromUserFullanme -->
            <search-input
              :inputValue="incomeOutcomePercentFilters.fromUserFullanme"
              inputLabel="جستجو بر اساس نام زبان آموز"
              inputPlaceholder="امیر..."
              v-model="incomeOutcomePercentFilters.fromUserFullanme"
              @enter="setFilters"
            ></search-input>
            <!-- fromUserMobile -->
            <search-input
              :inputValue="incomeOutcomePercentFilters.fromUserMobile"
              inputLabel="جستجو بر اساس شماره همراه زبان آموز"
              inputPlaceholder="0912..."
              v-model="incomeOutcomePercentFilters.fromUserMobile"
              @enter="setFilters"
            ></search-input>
            <chart-types-dropdown
              @getChartType="setChartType"
              class="w-24 filters-width"
            ></chart-types-dropdown>
          </filters-wrapper>

          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <b-col cols="12">
                <general-pie-chart
                  ref="chart"
                  :getChartData="getIncomeOutcomePercentChartData"
                >
                </general-pie-chart>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      incomeOutcomePercentFilters: {
        pageNumber: 1,
        count: 50,
        type: null,
        fromDate: null,
        toDate: null,
        fromUserFullanme: null,
        fromUserMobile: null,
        toUserFullanme: null,
        toUserMobile: null,
        courseId: null,
        lessonId: null,
        fromUserId: null,
        toUserId: null,
        priceCategoryId: null,
        description: null,
        orderId: null,
        vipUserId: null,
        price: null,
      },
    };
  },
  methods: {
    setFilters() {
      this.$refs?.chart?.sendChartRequest();
    },
    setChartType(chartType) {
      this.incomeOutcomePercentFilters.type = chartType;
    },
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.incomeOutcomePercentFilters.fromDate = new Date(
          dateRange[0]
        ).toISOString();
        this.incomeOutcomePercentFilters.toDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.incomeOutcomePercentFilters.fromDate = null;
        this.incomeOutcomePercentFilters.toDate = null;
      }
    },
    async getIncomeOutcomePercentChartData(_this) {
      let that = this;
      try {
        this.isLoading = true;
        let getIncomeOutcomePercentChart = new GetIncomeOutcomePercentChart(
          _this
        );
        getIncomeOutcomePercentChart.setRequestParamDataObj(
          that.incomeOutcomePercentFilters
        );
        await getIncomeOutcomePercentChart.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) => `${(+value).toFixed(2)}%`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    FiltersWrapper,
    GeneralPieChart,
    BCard,
    BRow,
    BCol,
    BOverlay,
    RangeDatePicker,
    SearchInput,
    ChartTypesDropdown,
  },
};
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import GeneralPieChart from "@/views/dashboard/analytics/IncomeOutcome/GeneralPieChart.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
import { GetIncomeOutcomePercentChart } from "@/libs/Api/IncomeOutcomeTransaction";
import ChartTypesDropdown from "@/views/components/Utils/ChartTypesDropdown.vue";
</script>